<template>
  <div class="review-real-usage-detail">
    <BoardDetail
      v-if="reviewDetail"
      :board-id="id"
      :board="reviewDetail"
      list-path="/reviews/real-usage"
    />
  </div>
</template>

<script>
import BoardDetail from "@/components/BoardDetail.vue";
import { fetchRealUsageReviewDetail } from '@/api';

export default {
  name: 'ReviewRealUsageDetail',
  components: {
    BoardDetail
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      reviewDetail: null,
      loading: false,
      error: null
    };
  },
  async created() {
    await this.loadReviewDetail();
  },
  methods: {
    async loadReviewDetail() {
      this.loading = true;
      this.error = null;

      try {
        const response = await fetchRealUsageReviewDetail(this.id);
        const review = response.data;

        // 이미지 파일 확장자 정의
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
        const images = [];
        const contentsHtml = review.contents || '';

        if (review.attachments && review.attachments.length > 0) {
          review.attachments.forEach(att => {
            // 썸네일(main)·에디터 본문 이미지(editor)는 상단 갤러리에서 제외
            if (att.type === 'editor' || att.type === 'main') {
              return;
            }
            const ext = att.originalname ?
              att.originalname.substring(att.originalname.lastIndexOf('.')).toLowerCase() : '';

            if (!imageExtensions.includes(ext)) {
              return;
            }

            // 본문(contents)에 이미 삽입된 이미지는 중복 노출 방지
            if (att.filename && contentsHtml.indexOf(att.filename) !== -1) {
              return;
            }
            if (att.download_url && contentsHtml.indexOf(att.download_url) !== -1) {
              return;
            }

            images.push(att.download_url);
          });
        }

        this.reviewDetail = {
          id: review.id,
          type: review.type,
          title: review.title,
          contents: review.contents,
          images: images,
          mod_dttm: review.mod_dttm,
          created_dttm: review.created_dttm,
          attachments: review.attachments || []
        };

      } catch (error) {
        this.error = '데이터를 불러오는 중 오류가 발생했습니다.';
        console.error('===== API 호출 에러 =====');
        console.error('에러:', error);
        console.error('에러 상세:', error.response?.data || error.message);
        console.error('========================');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.review-real-usage-detail {
  width: 100%;
  min-height: 55px;
}
</style>
